import { ChefHat, Music, TreePine, Building2, Wine, Truck, MapPin, Banknote } from 'lucide-react';

const differentials = [
  {
    icon: ChefHat,
    title: 'Culinária baiana e nordestina',
    desc: 'Sabores autênticos que trazem a essência do Nordeste para sua mesa.',
  },
  {
    icon: Music,
    title: 'Música ao vivo',
    desc: 'Noites embaladas por bons músicos e o melhor da música brasileira.',
  },
  {
    icon: TreePine,
    title: 'Área Climatizada',
    desc: 'Aproveite o clima agradável e a vibe da Varjota ao ar livre.',
  },
  {
    icon: Building2,
    title: 'Mesas na cobertura',
    desc: 'Espaço na cobertura com vista e clima perfeito para a noite.',
  },
  {
    icon: Wine,
    title: 'Drinks com paixão',
    desc: 'Drinks bem preparados que fazem toda a diferença na experiência.',
  },
  {
    icon: Truck,
    title: 'Delivery',
    desc: 'Sabores do Buteco do Baiano na sua casa, com delivery disponível.',
  },
  {
    icon: MapPin,
    title: 'Localização na Varjota',
    desc: 'No coração de um dos bairros mais vibrantes de Fortaleza.',
  },
  {
    icon: Banknote,
    title: 'Faixa de preço acessível',
    desc: 'Experiência completa com preço justo: R$ 40-120 por pessoa.',
  },
];

export default function DifferentialsSection() {
  return (
    <section className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              POR QUE O BUTECO
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              Diferenciais
            </h2>
            <p className="text-brown-600 text-base md:text-lg max-w-2xl mx-auto">
              O que faz o Buteco do Baiano um bichinho especial na região da Varjota.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {differentials.map((item, i) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 group reveal"
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold-500/10 text-gold-500 mb-4 group-hover:bg-gold-500 group-hover:text-white transition-colors duration-300">
                  <item.icon size={24} />
                </div>
                <h3 className="font-heading text-lg font-bold text-brown-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-brown-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
